export default {
  table: {
    marginLeft: '30px',
    width: '95%',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Movements/components/InventoryMovements/styles.js